import React, { useEffect } from "react";
import { Route, Switch } from "react-router-dom";
import Home from "../pages/Home/index";

import { useLocation } from "react-router-dom";
import { useSelector } from "react-redux";
import Restuarantes from "../components/Restuarantes/Restuarantes";
import RestuarantDetailpage from "../components/Restuarantes/RestuarantDetailpage";
import MyEarnings from "../pages/MyEarnings/MyEarnings";
import CardPage from "../components/LoginScreens/CardPage";
import Reward from "../components/LoginScreens/Reward";
import Login from "../components/Login/Login";
import { TermsAndConditions } from "../components/TermsAndConditions/Index";
import { PrivacyPolicy } from "../components/PrivacyPolicy";


const MainRoutes: React.FC = () => {
  const { pathname } = useLocation();

  const { user } = useSelector((reduxState: any) => reduxState.auth);
  const vendorId = user?.vendorId;

  useEffect(() => {
    window.scrollTo(0, 0);
  }, [pathname]);

  const isAdmin = window.location.pathname?.split("/")[1] === "admin" ? true : false;

  return (
    <Switch>
      <Route exact path="/Home" component={Home} />
      <Route exact path="/Restuarantes" component={Restuarantes} />
      <Route exact path="/myearnings" component={MyEarnings} />
      <Route exact path="/Restuarante-details/:id" component={RestuarantDetailpage} />
      <Route exact path="/login" component={Login} />
      <Route exact path="/cardpage" component={CardPage} />
      <Route exact path="/rewards" component={Reward} />
      <Route exact path="/privacypolicy" component={PrivacyPolicy} />
      <Route exact path="/termsandconditions" component={TermsAndConditions} />


    </Switch>
  );
};

export default MainRoutes;
